import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ReportKind } from '../../typings/reports';

import './ReportsKindCell.css';
import * as keyset from './ReportsKindCell.i18n';

const i18n = i18nFactory(keyset);

export interface ReportsKindCellProps {
    kind?: ReportKind;
}

export class ReportsKindCell extends React.PureComponent<ReportsKindCellProps> {
    render() {
        const { kind } = this.props;

        if (!kind) {
            return (
                <div
                    className={Bem.cls({
                        block: 'reports-kind-cell'
                    })}
                >
                    –
                </div>
            );
        }

        let kindtext: string;
        switch (kind) {
            case ReportKind.full:
                kindtext = i18n('full');
                break;
            default:
            case ReportKind.partial:
                kindtext = i18n('partial');
                break;
        }

        return (
            <div
                className={Bem.cls({
                    block: 'reports-kind-cell',
                    mods: { theme: kind.toLowerCase() }
                })}
            >
                {kindtext}
            </div>
        );
    }
}
